import { apiFetch } from './apiClient';

export interface LoginResponse {
  token: string;
  user: {
    id: number;
    username: string;
    isAdmin: boolean;
    permissions: string[];
    subModules: Record<string, unknown> | null;
  };
}

export const authService = (token: string | null) => ({
  login: (username: string, password: string) =>
    apiFetch<LoginResponse>(null, '/api/auth/login', {
      method: 'POST',
      body: JSON.stringify({ username, password }),
    }),
  logout: () => apiFetch<void>(token, '/api/auth/logout', { method: 'POST' }),
});
